export default {
    buscando: false,
    items: [],
    tratativas: [],
    paginacao: null
}